import React, { useEffect, useRef, useState } from 'react';
import { data } from '../Constant/data';
import { NavLink } from 'react-router-dom';

const Header = ({ currentSection }) => {
    const headerData = data.header;
    const [scrollTop, setScrollTop] = useState(0);
    const [toggleStatus, setToggleStatus] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const headerRef = useRef();

    useEffect(() => {
        const handleScroll = () => {
            setScrollTop(window.scrollY);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const activeNavItem = headerData?.navLinks?.findIndex(
            (el) => el.href === `#${currentSection}`
        );
        setActiveIndex(activeNavItem !== -1 ? activeNavItem : 0);
    }, [currentSection, headerData?.navLinks]);

    const handleScrollToSection = (e, href, index) => {
        e.preventDefault();

        if (href.startsWith('#')) {
            const targetElement = document.querySelector(href);
            if (targetElement) {
                const headerHeight = headerRef.current?.offsetHeight || 0;
                const scrollPosition = targetElement.offsetTop - headerHeight + 10;
                window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
                setActiveIndex(index);
                setToggleStatus(false);
            }
        } else {
            window.open(href, '_blank');
        }
    };

    return (
        <header className={scrollTop >= 30 ? 'fixed' : ''} ref={headerRef}>
            <div className="container">
                <button
                    id="nav-toggle"
                    className={toggleStatus ? 'active' : ''}
                    onClick={() => setToggleStatus((prev) => !prev)}
                >
                    <span></span>
                </button>
                <nav className={toggleStatus ? 'active' : ''}>
                    <ul>
                        {headerData?.navLinks?.map((el, index) => (
                            <li key={index} className={activeIndex === index ? 'current' : ''}>
                                <NavLink
                                    to={el.href}
                                    {...(el?.customScroll && { onClick: (e) => handleScrollToSection(e, el.href, index) })}
                                    className={`text_sm3 `}
                                >
                                    {el.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                    <div className="right">
                        <span className='text_sm3'>Already have an account?</span>
                        <NavLink to={headerData?.signIn?.href} className="btn secondary text_sm3">
                            {headerData?.signIn?.label}
                        </NavLink>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
